import { render, staticRenderFns } from "./AccountBar.vue?vue&type=template&id=4c6a87cc&"
import script from "./AccountBar.vue?vue&type=script&lang=js&"
export * from "./AccountBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountBar.vue"
export default component.exports